jQuery(document).ready(function ($) {
    const attr = 'data-lightbox';

    $.fn.lightbox = function () {
        return this.attr('data-lightbox');
    }

    $(document).on('click', '.js-lightbox-toggle', function (event) {
        event.preventDefault();
        let name = $(this).lightbox();
        $(`.js-lightbox[data-lightbox="${name}"]`).fadeToggle();
    });

    $(document).on('click', '.js-lightbox-close', function (event) {
        event.preventDefault();
        $('.js-lightbox').fadeOut();
    });

    let lightboxes = [];
    let lightbox_navs = [];

    function getImages(gallery) {
        const images = gallery.find('img');

        const elements = [];

        images.each(function () {
            const src = 'src:' + $(this).attr('src');
            const alt = 'alt:' + $(this).attr('alt');
            const id = 'id:' + $(this).parent().attr('data-attachment-id');

            elements.push({image: [src, alt, id]});
        });

        return JSON.stringify(elements);
    }

    $.fn.generateLightboxes = function () {
        const galleries = $('[data-lightbox-name]');

        $('<div class="lightboxes"></div>').insertAfter('footer');

        const _this = this;

        galleries.each(function () {
            const name = $(this).attr('data-lightbox-name');

            const images = getImages($(this));

            const gallery = this;

            console.log(name);
            console.log(images);

            $.ajax({
                url: lightbox.ajax_url,
                type: 'POST',
                data: {
                    name: name,
                    images: images,
                    action: 'get_lightbox',
                    nonce: lightbox.nonce
                },

                beforeSend: function () {
                    console.log(`retrieving lightbox for ${name}...`)
                },

                success: function (response) {
                    $('.lightboxes').append(response.data.html);

                    $(gallery).find('.expand-image').fadeIn(500);

                    return _this.registerLightboxes();
                },

                error: function (error) {
                    console.log(error);

                    return _this;
                }
            });
        });
    }

    $.fn.registerLightboxes = function () {
        let i = 0;

        console.log('registering lightboxes...');

        console.log($('.js-lightbox'));

        $('.js-lightbox').each(function () {
            lightbox_navs.push(new Swiper(`.js-lightbox[data-lightbox="${$(this).lightbox()}"] .js-lightbox-thumbs`, {
                loop: true,

                slidesPerView: 100,
                slidesPerGroup: 100,

                autoplay: true,
                delay: 4000,

                grabCursor: true,

                freeMode: true,
                watchSlidesProgress: true,

                centeredSlides: true,
                centeredSlidesBounds: true,
                centerInsufficientSlides: true,

                slideClass: 'js-lightbox-thumbs__slide'
            }));

            lightboxes.push(new Swiper(`.js-lightbox[data-lightbox="${$(this).lightbox()}"] .js-lightbox-main`, {
                loop: true,

                slidesPerView: 1,

                autoplay: true,
                delay: 4000,

                grabCursor: true,

                navigation: {
                    prevEl: '.js-lightbox-main__prev',
                    nextEl: '.js-lightbox-main__next'
                },

                slideClass: 'js-lightbox-main__slide',

                thumbs: {
                    swiper: lightbox_navs[i],
                    slideThumbActiveClass: 'active'
                }
            }));

            i++;
        });

        console.log(lightboxes);

        return this;
    }

    $(document).generateLightboxes();

    //console.log(lightboxes);
});